export enum QuestionType {
  CHOICE = 0,
  TEXT = 1,
  WORD_CLOUD = 2,
  SWIPE = 3,
}
